<template>
  <a-modal
    :title="title"
    :width="1100"
    :visible="visible"
    :bodyStyle="bodyStyle"
    :destroyOnClose="true"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    okText="保存"
    :okButtonProps="{ props: {disabled: (disableSubmit)} }"
    cancelText="关闭">
    <a-card  :bordered="false">
      <div class="table-operator">
        <a v-if="!disableSubmit" @click="selectSubject()" class="ant-btn ant-btn-primary" style="margin-right: 10px;">选择标的</a>
      </div>
      <a-row>
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="idCardNum"
          :columns="columnsSubject"
          :dataSource="subjectList"
          :pagination="false"
          class="j-table-force-nowrap">
              <span slot="action" slot-scope="text, record ,index">
                <a  v-if="!disableSubmit && signPartShow" @click="delSub(index)">删除<a-divider type="vertical"/></a>
                <a @click="viewSubject(record)">查看</a>
              </span>
        </a-table>
      </a-row>
    </a-card>
    <a-card title="附件信息" :bordered="false" >
      <span v-for="(item,i) in folderDefine" :key="i" v-if="!disableSubmit">
          <span style="color: red;" v-show='item.isNeed == 1'>*</span>
          <a-upload
            name="file"
            :multiple="false"
            :action="uploadAction"
            :headers="tokenHeader"
            :data="item"
            :accept="item.accept == null? '*':item.accept"
            :showUploadList="false"
            :beforeUpload="beforeFileUpload"
            :remove="handleFileRemove"
            @change="handleFileChange">
            <a-button  style="margin-right:8px;position: relative" >
              <a-icon type="upload"/>
              {{item.typeZh}}
            </a-button>

          </a-upload>
        </span>
      <a-table
        ref="filetable"
        size="middle"
        bordered
        :rowKey="(record,index)=>{return index}"
        :columns="columnsFile"
        :dataSource="modal.fileList"
        :loading="loading"
        :pagination="false"
        @change="handleTableChange"
        style="margin-top:5px">
            <span slot="action" slot-scope="text, filesub,index">
              <a @click="deleteFile(index)" v-if="!disableSubmit && signPartShow">删除<a-divider type="vertical"/></a>
              <a v-if="filesub.id!=null && signPartShow &&!disableSubmit"   @click="signFile(filesub)" >签章<a-divider type="vertical"/></a>
              <a v-if="(userInfo.roleCode==='pr_comprehensive'||(userInfo.roleCode==='pr_principal'&& modal.delegationType==='2')) && modal.comprehensiveIsSign!=='1' && signComPartShow "   @click="signComFile(filesub)" >签章<a-divider type="vertical"/></a>

              <a @click="handleDownload(filesub)">下载</a>
            </span>
      </a-table>
    </a-card>

    <j-select-pr-subject-modal ref="subjectModal" @setSubject="setSubject" />
    <subject-view-modal ref="subjectViewModal" ></subject-view-modal>
    <SignFileShow-modal ref='modalForm3'></SignFileShow-modal>
    <SignatureComponent
      ref='stamp'
      v-show="pdfCententShow"
      :pdf-params='pdfParams'
      @checkStampForm='checkStampForm'
      @changeIsStamp='changeIsStamp'
    ></SignatureComponent>
  </a-modal>
</template>

<script>
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";
import {downloadFile, getAction, postAction} from "@api/manage";
import {FzisListMixin} from "@/mixins/FzisListMixin";
import JSelectPrSubjectModal from "@comp/fzisbiz/propertyright/JSelectPrSubjectModal.vue";
import SubjectStep4Modal from "@views/propertyright/modules/SubjectStep4Modal.vue";
import SubjectStep3Modal from "@views/propertyright/modules/SubjectStep3Modal.vue";
import SubjectStep2Modal from "@views/propertyright/modules/SubjectStep2Modal.vue";
import SubjectStep5Modal from "@views/propertyright/modules/SubjectStep5Modal.vue";
import SubjectViewModal from "@views/propertyright/modules/SubjectViewModal.vue";
import SignatureComponent from "@comp/SignatureComponent";
import SignFileShowModal from "@views/bobidopen/modules/SignFileShowModal.vue";
import SignFileShow from "@views/bobidopen/modules/SignFileShow.vue";
import {mapGetters} from "vuex";

export default {
  name: "DelagationAgentModal",
  components: {
    SignFileShow,
    SignFileShowModal, SignatureComponent,
    SubjectViewModal,
    SubjectStep5Modal, SubjectStep2Modal, SubjectStep3Modal, SubjectStep4Modal,
    JSelectPrSubjectModal},
  mixins:[FzisListMixin],
  data () {
    return {
      tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
      title: "选择分配的标的",
      signPartShow:false,
      signComPartShow:false,
      bodyStyle:{
        padding: "0",
        overflow:"auto",
        // height:(window.innerHeight-100)+"px"
        height:"550px"
      },
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      pdfCententShow:false,
      modal:{},
      id:"",
      subjectList:[],
      fileList:[],
      url: {
        addOrUpdate: "/ebid-ce/propertyright/prDelegationAgentProtocol/addOrUpdate",
        minioDownload: "/ebid-ce/file/minioDownload"
      },
      folderDefine:[{typeZh:'委托代理协议',isNeed:'1',accept:'.jpg,.png,.pdf',type:'prDelagationProto',fp:12}],
      subjectIds:"",
      columnsSubject:[{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function (t, r, index) {
          return parseInt(index) + 1;
        }
        },
        {
          title: '标的名称',
          align: "center",
          dataIndex: 'subjectName'
        },
        {
          title: '标的编号',
          align: "center",
          dataIndex: 'subjectCode'
        },
        {
          title: '转让方',
          align: "center",
          dataIndex: 'transEnterpriseName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'},
        }
      ],
      columnsFile:[{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function (t, r, index) {
          return parseInt(index) + 1;
        }
        },
        {
          title: '文件名称',
          align: "center",
          dataIndex: 'fileName'
        },
        {
          title: '文件类型',
          align: "center",
          dataIndex: 'typeZh'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'},
        }],
      pdfParams: {
        pageId: '',
        signedPdfUrl: '',
        sourceUrl:'',
        bidProjectId: '',
        sectionId: '',
        type: 'prDelegationAgentProtoStamp',
        typeZh: '委托协议代理签章',
        htmlTitle: '委托协议代理签章',
        fp: '12',
        signType: '1',//1:统一CA，2：工改签章
        saveTmFileFlag:"0"//自动保存
      },
    }
  },
  computed: {
    ...mapGetters(['username', 'nickname', 'userInfo']),
    uploadAction() {
      return window._CONFIG['domianURL'] + '/ebid-ce/file/onlyUpload'
    },
  },
  methods:{
    handleCancel () {
      this.$emit('close');
      this.$emit('loadData');
      this.visible = false;
    },
    add () {
      this.modal={};
      this.id=null;
      this.subjectList=[];
      this.visible = true;
    },
    edit(record){
      this.visible = true;
      this.id=record.id;
      this.modal=record;
      this.getsubjectList();
      this.getfileList();
      if(record.signFileUrl==null)
      {
        this.signPartShow=true;
      }else
      {
        this.signPartShow=false;
      }
      if(record.comprehensiveSignFileUrl==null)
      {
        this.signComPartShow=true;
      }else
      {
        this.signComPartShow=false;
      }
    },
    getsubjectList()
    {
      let that=this;
      getAction("/ebid-ce/propertyright/prDelegationAgentProtocol/getSubject/"+ this.id).then(res => {
        if(res.success) {
          that.subjectList=res.result;
        }
      })
    },
    getfileList()
    {
      let that=this;
      getAction("/ebid-ce/propertyright/prDelegationAgentProtocol/file/list",{id:this.id}).then(res => {
        if(res.success) {
          that.modal.fileList=res.result;
          that.$forceUpdate();
        }
      })
    },
    handleDownload(rec) {
      var that = this;
      if(this.modal.comprehensiveSignFileUrl!=null)
      {
        downloadFile(this.modal.comprehensiveSignFileUrl , "委托协议签章.pdf");
        return;
      }
      if(this.modal.signFileUrl!=null)
      {
        downloadFile(this.modal.signFileUrl , "委托协议签章.pdf");
        return;
      }

      getAction(that.url.minioDownload,{id: rec.id}).then(res => {
        if(res.success) {
          console.log("res.res.res.",res)
          downloadFile(res.result , rec.fileName);
        }
      })
    },
    deleteFile(index) {
      const that = this
      that.modal.fileList.splice(index,1);
      this.$forceUpdate()
     // this.record.fileList=this.record.fileList.filter(item => item.id != fileId);
    },
    //保存
    handleOk(){
      const that = this;
      if(this.subjectList.length<1)
      {
        this.$message.warning("标的不能为空");
        return;
      }
      if(this.modal.fileList.length<1)
      {
        this.$message.warning("附件不能为空");
        return;
      }
      let formData ={};
      formData.fileList=this.modal.fileList;
      formData.id=that.id;
      formData.protocolType="1";
      formData.subjectList=this.subjectList;
      if(that.modal.fileList.length<1)
      {
        that.$message.warn("请先上传附件！");
        return;
      }
      console.log("formData",formData)
      that.confirmLoading=true;
      postAction(that.url.addOrUpdate,formData).then(res => {
        if (res.success) {
          that.$message.info("保存成功！");
          that.visible=false
          that.$emit('loadData');
          return;
        }
        else
        {
          that.$message.error(res.message);
        }
      }).finally(() => {
        that.confirmLoading=false;
      });
    },
    selectSubject()
    {
      this.$refs.subjectModal.visible = true
      this.$refs.subjectModal.multiple=true;
      this.$refs.subjectModal.queryParam.isDistribution="1";
      this.$refs.subjectModal.queryParam.isDelegation="0";
      this.$refs.subjectModal.queryParam.distributionBy=this.$store.getters.userInfo.id;
      this.$refs.subjectModal.queryParam.isFirstLoad = true
      this.$refs.subjectModal.reloadData();
    },
    setSubject(record,index)
    {
      for(let i in record)
      {
        record[i].subjectId=record[i].id;
        record[i].id=null;
      }
      this.subjectList=this.subjectList.concat(record);
    },
    delSub(index)
    {
      this.subjectList.splice(index, 1);
    },
    viewSubject(record)
    {
      this.$refs.subjectViewModal.visible=true;
      this.$refs.subjectViewModal.modal=record;
      this.$refs.subjectViewModal.reload(record);
      // this.$refs.modalForm.add();
    },
//附件相关
    beforeFileUpload(file) {
      //限制文件大小
      const isLt = file.size / 1024 / 1024 < 100
      if (!isLt) {
        this.$message.error('上传的文件大小不能超过100M')
        return false
      }
      this.fileList.push(file);
      return true
    },
    handleFileRemove(file)
    {
      if(file.response && this.fileList!=null)
      {
        this.modal.fileList=this.modal.fileList.filter(item => item != file.response.result);
      }
      this.$forceUpdate()
    },
    handleFileChange(info) {
      //console.log("chg",info);
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          this.fileUploadOk(info.file.response)
        } else {
          for (let i = 0; i < info.fileList.length; i++) {
            if (info.file.uid == info.fileList[i].uid) {
              info.fileList[i].status = 'error'
              break
            }
          }
          this.fileUploadFail(info.file.response)
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    fileUploadOk(response) {
      if(this.modal.fileList==null)
      {
        this.modal.fileList=[];
      }
      if(this.modal.fileList.length>0)
      {
        this.$message.error("只能上传一个附件");
        return;
      }
      this.modal.fileList.push(response.result);
      this.$forceUpdate()
    },
    fileUploadFail(response) {
      this.$message.error(response.message)
    },
    //电子签章
    signFile(fileSub,type)
    {
      //获取系统原地址
      let that=this;
      that.signPartShow=false;
      that.pdfParams.sourceUrl=that.modal.fileList[0].fileUrl;
      that.pdfParams.sectionId=that.id;
      console.log("that.pdfParams",that.pdfParams)
      that.$refs.stamp.checkStamp();
    },
    signComFile()
    {
      //获取系统原地址
      let that=this;
      that.signComPartShow=false;
      that.pdfParams.sourceUrl=that.modal.signFileUrl;
      that.pdfParams.sectionId=that.id;
      that.pdfParams.type='prDelegationAgentProtoComStamp';
      that.pdfParams.typeZh='委托代理协议综合部签章';
      that.$refs.stamp.checkStamp();
    },
    changeIsStamp(val) {
      console.log("val",val);
    },
    checkStampForm(callback) {
      callback(true)
    },
    signFileShow() {
      this.$refs.modalForm3.show(this.sectionId, this.pdfParams.type)
    },
  }
}
</script>

<style scoped>
.labelTop{
  margin-top: 10px;
  text-align: right;
  color:#262626;
}
</style>